import React, { useState, useRef, useEffect } from 'react';
import { createPopper } from '@popperjs/core';
import { XIcon } from '@phosphor-icons/react';

const HoverBox = ({
  tabIndex = 0,
  id,
  svg,
  className,
  tooltipHeader,
  toolTipDescription,
  position = 'top',
  variant = 'black',
  children,
  showCloseIcon = false,
  xOffset = 0,
  yOffset = 8,
  handleSvgClick = () => { },
  disablePointer = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isIconClicked, setIsIconClicked] = useState(false);
  const referenceElement = useRef(null);
  const popperElement = useRef(null);
  const popperInstance = useRef(null);

  useEffect(() => {
    if (referenceElement.current && popperElement.current) {
      popperInstance.current = createPopper(referenceElement.current, popperElement.current, {
        placement: position,
        strategy: 'fixed',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [xOffset, yOffset]
            }
          },
          {
            name: 'eventListeners',
            enabled: isOpen
          },
        ]
      });
    }
    return () => {
      if (popperInstance.current) {
        popperInstance.current.destroy();
      }
    };
  }, [position, xOffset, yOffset, isOpen]);

  const baseStyle = {
    display: isOpen ? 'block' : 'none',
  };

  const style = {
    maxWidth: '250px',
    borderRadius: '5px',
    padding: '6px 12px',
    width: 'max-content',
    zIndex: 1000,
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: variant === 'white' ? '#FFFFFF' : variant === 'warning' ? '#FFA940' : variant === 'black' ? '#000000' : '#424242',
    color: variant === 'white' ? '#000000' : variant === 'warning' ? '#000000' : variant === 'black' ? '#FFFFFF' : '#FFFFFF',
    display: isOpen ? 'block' : 'none',
  };

  return (
    <div tabIndex={tabIndex} id={id} className={`relative ${className}`}>
      <div
        ref={referenceElement}
        onMouseEnter={() => {
          setIsOpen(true);
          setIsIconClicked(false);
        }}
        onMouseLeave={() => {
          if (!isIconClicked) {
            setIsOpen(false);
          }
        }}
        onClick={() => {
          setIsOpen(!isOpen);
          setIsIconClicked(true);
          handleSvgClick();
        }}
        className={`w-full h-full flex justify-center items-center rounded-lg ${!disablePointer ? 'cursor-pointer' : 'cursor-default'}`}
      >
        {svg}
      </div>
      <div ref={popperElement} style={style} className={'popper-tooltip'} data-popper-placement={position} data-variant={variant}>
        <div className={`text-sm flex flex-col ${tooltipHeader && toolTipDescription ? 'gap-2' : ''}`}>
          <div className="flex justify-between">
            <h4 className="font-bold leading-4 text-sm">{tooltipHeader}</h4>
            {showCloseIcon && <XIcon size={14} onClick={() => setIsOpen(false)} />}
          </div>
          <p className={`font-normal leading-5 ${tooltipHeader ? 'text-sm' : 'text-xs'}`}>{toolTipDescription}</p>
          {children && React.cloneElement(children, { onClick: () => setIsOpen(false) })}
        </div>
      </div>
    </div>
  );
};
export default HoverBox;
